import { render, staticRenderFns } from "./EditDoctor.vue?vue&type=template&id=69c4deee&scoped=true"
import script from "./EditDoctor.vue?vue&type=script&lang=js"
export * from "./EditDoctor.vue?vue&type=script&lang=js"
import style0 from "./EditDoctor.vue?vue&type=style&index=0&id=69c4deee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c4deee",
  null
  
)

export default component.exports